import React from 'react';
import type { InputHTMLAttributes } from 'react';
import type { AllColorType } from '../../util/types';
import { TOGGLE_SLIDER, TOGGLE_WRAPPER } from '../../util/data-id';
import { ToggleStyled, ToggleWrapStyled } from './Toggle.styled';

type Ref = HTMLInputElement;
type HTMLProps = Omit<InputHTMLAttributes<Ref>, 'type'>;
interface Props extends HTMLProps{
  id: string;
  label: string;
  color?: AllColorType;
  isOnOff?: boolean;
  isInverted?: boolean;
}

const Toggle = React.forwardRef<Ref, Props>(({
  id,
  label,
  color = 'primary',
  isOnOff = false,
  isInverted = false,
  ...other
}: Props, ref): JSX.Element => (
  <ToggleWrapStyled
    data-id={TOGGLE_WRAPPER}
    $color={color}
    $isOnOff={isOnOff}
    $isChecked={'checked' in other ? !!other.checked : false}
    $isDisabled={'disabled' in other ? !!other.disabled : false}
    $isInverted={isInverted}
  >
    <ToggleStyled
      ref={ref}
      id={id}
      aria-label={label}
      {...other as HTMLProps}
    />
    <div
      data-id={TOGGLE_SLIDER}
      data-animation={'checked' in other ? !!other.checked : false}
      data-cy={TOGGLE_SLIDER}
    />
  </ToggleWrapStyled>
));

export default Toggle;
